import React, { Component } from 'react'
import axios from 'axios'
import { APIURL } from '../../../config/config'
import moment from 'moment'
import 'react-datepicker/dist/react-datepicker.css';
import MaskedInput  from 'react-maskedinput'
import 'moment/locale/th';
moment.locale('th');

export  default class CustomerForm extends Component{
    constructor(props){
        super(props);
        this.state={
            lists: [],
            load_data: true,
            danger: false,
            customer_id:0,
            action: "บันทึก",
            customer: '' ,
            startDateCustomerNew1: moment().format('YYYY-MM-DD'),
        }
        this.handleDateCustomerNew1 = this.handleDateCustomerNew1.bind(this);
        this.convertBBtoCC = this.convertBBtoCC.bind(this);
        this.onMaskedDateCustomerNew1 = this.onMaskedDateCustomerNew1.bind(this);
    }

    handleOnSubmitCustomer(event){
        event.preventDefault()
        let that = this ;
        let customer_name = event.target.customer_name.value
        let customer_lastname = event.target.customer_lastname.value
        let customer_card_id = event.target.customer_card_id.value
        let customer_birth = this.state.startDateCustomerNew1
        let customer_age = event.target.customer_age.value
        let customer_mobile = event.target.customer_mobile.value
        let customer_address = event.target.customer_address.value
        let customer_gender = event.target.customer_gender.value
        let customer_housing = event.target.housing.value
        let customer_housing_other = event.target.customer_housing_other.value
        //
        let guarantor_name = event.target.guarantor_name.value
        let guarantor_address = event.target.guarantor_address.value
        let guarantor_mobile = event.target.guarantor_mobile.value

        if(customer_name===''){
            return ;
        }
        event.target.customer_name.value = ""
        event.target.customer_lastname.value = ""
        event.target.customer_card_id.value = ""
        event.target.customer_age.value = ""
        event.target.customer_mobile.value = ""
        event.target.customer_address.value = ""
        //
        event.target.guarantor_name.value = ""
        event.target.guarantor_address.value = ""
        event.target.guarantor_mobile.value = ""

        axios.post(APIURL + '/customer/', {
            customer_name: customer_name,
            customer_lastname: customer_lastname,
            customer_card_id : customer_card_id,
            customer_birth: customer_birth,
            customer_age : customer_age,
            customer_mobile: customer_mobile,
            customer_address : customer_address,
            username: 'admin',
            guarantor_name: guarantor_name,
            guarantor_address: guarantor_address,
            guarantor_mobile: guarantor_mobile,
            customer_gender: customer_gender,
            customer_housing: customer_housing,
            customer_housing_other: customer_housing_other
        })
            .then(function (response) {
                that.props.onToggle(response && response.data && response.data.customer_id);
            })
            .catch(function (error) {
                //alert("error:"+error)
            })
    }

    handleDateCustomerNew1(date) {
        this.setState({
            startDateCustomerNew1: moment(date).format('YYYY-MM-DD')
        });
    }

    onMaskedDateCustomerNew1 (e){
        let buddhist_date = e.target.value ;
        //alert('date='+date);
        if(buddhist_date.length===10){
            let cc_date = this.convertBBtoCC(buddhist_date)
            this.handleDateCustomerNew1(cc_date)
        }
    }

    convertBBtoCC(buddhist_date){ //dd-mm-yyyy to yyyy-mm-dd
        let date_arr=buddhist_date.split('-');
        let dd = date_arr[0];
        let mm = date_arr[1];
        let yyyy = date_arr[2]-543;
        let cc_date= yyyy+'-'+mm+'-'+dd ;
        if(moment(cc_date, 'YYYY-MM-DD', true).isValid()){
            //alert(cc_date);
            return cc_date ;
        }
        return moment() ;
    }

    render(){
        //const { history } = this.props
        return(
            <div className="card card-accent-primary">
                <form action="" method="post" onSubmit={this.handleOnSubmitCustomer.bind(this)}>
                    <div className="card-header">
                        <strong>ข้อมูลลูกค้าใหม่</strong>
                    </div>

                <div className="card-block">
                    <div className="row">
                        <div className="form-group col-sm-6">
                            <label htmlFor="customer_name">ชื่อ</label>
                            <input type="text"
                                   className="form-control"
                                   id="customer_name"
                                   placeholder=""
                            />
                        </div>
                        <div className="form-group col-sm-6">
                            <label htmlFor="customer_lastname">นามสกุล</label>
                            <input type="text"
                                   className="form-control"
                                   id="customer_lastname"
                                   placeholder=""
                            />
                        </div>

                        <div className="form-group col-sm-12">
                            <label htmlFor="customer_address">ที่อยู่ปัจจุบัน</label>
                            <input type="text"
                                   className="form-control"
                                   id="customer_address"
                                   placeholder=""
                            />
                        </div>

                        <div className="form-group col-sm-6">
                            <label htmlFor="customer_card_id">เลขบัตรประชาชน</label>
                            <input type="text"
                                   className="form-control"
                                   id="customer_card_id"
                                   maxLength="13"
                                   placeholder=""
                            />
                        </div>

                        <div className="form-group col-sm-6">
                            <label htmlFor="customer_birth_text">วันเดือนปีเกิด (พ.ศ.)</label>
                            <MaskedInput
                                mask="11-11-1111"
                                name="customer_birth_text"
                                placeholder="dd-mm-yyyy"
                                onChange={this.onMaskedDateCustomerNew1}
                                className="form-control"
                            />
                            {/*<DatePicker
                                selected={this.state.startDateCustomerNew1}
                                onChange={this.handleDateCustomerNew1}
                                dateFormat="yyyy-MM-dd"
                                   type="text"
                                   className="form-control"
                                   id="customer_birth"
                                   name="customer_birth"
                                   placeholder=""
                            />*/}
                        </div>
                        <div className="form-group col-sm-6">
                            <label htmlFor="customer_age">อายุ</label>
                            <input type="text"
                                   className="form-control"
                                   id="customer_age"
                                   placeholder=""
                            />
                        </div>

                        <div className="form-group col-sm-6">
                            <label htmlFor="customer_mobile">เบอร์โทรศัพท์</label>
                            <input type="text"
                                   className="form-control"
                                   id="customer_mobile"
                                   placeholder=""
                            />
                        </div>

                        <div className="form-group col-sm-6">
                            <label>เพศ</label><br/>
                            <label className="mr-3"><input type="radio" name="customer_gender" value="ชาย"/> ชาย</label>
                            <label className="mr-3"><input type="radio" name="customer_gender" value="หญิง"/> หญิง</label>
                            <label><input type="radio" name="customer_gender" value="อื่นๆ"/> อื่นๆ</label>
                        </div>
                        <div className="form-group col-sm-6">
                            <label>ลักษณะที่พัก</label><br/>
                            <label className="mr-3"><input type="radio" name="housing" value="บ้านตัวเอง"/> บ้านตัวเอง</label>
                            <label className="mr-3"><input type="radio" name="housing" value="บ้านเช่า"/> บ้านเช่า</label>
                            <label className="mr-3"><input type="radio" name="housing" value="อื่นๆ"/> อื่นๆ</label>
                            <input type="text" className="form-control mt-2" name="customer_housing_other" placeholder="ระบุ (ถ้าอื่นๆ)"/>
                        </div>

                    </div>

                  <div className="row">
                        <div className="col-sm-12">
                            <hr />
                        </div>
                        <div className="col-sm-12">
                            <strong>ข้อมูลผู้ค้ำประกัน</strong>
                       </div>
                        <div className="form-group col-sm-12" style={{marginTop: 20}}>
                          <label htmlFor="guarantor_name">ชื่อ-นามสกุลผู้ค้ำ</label>
                          <input type="text"
                                 className="form-control"
                                 id="guarantor_name"
                                 placeholder=""
                          />
                        </div>
                        <div className="form-group col-sm-12">
                          <label htmlFor="guarantor_address">ที่อยู่ผู้ค้ำ</label>
                          <input type="text"
                                 className="form-control"
                                 id="guarantor_address"
                                 placeholder=""
                          />
                        </div>
                        <div className="form-group col-sm-12">
                          <label htmlFor="guarantor_mobile">เบอร์โทรผู้ค้ำ</label>
                          <input type="text"
                                 className="form-control"
                                 id="guarantor_mobile"
                                 placeholder=""
                          />
                        </div>
                      </div>
                    <div className="col-md-12 text-center">
                        <div className="card-block">
                            <button type="submit" className="btn btn-success btn-lg">
                                <i className="icon-check"></i>  บันทึกข้อมูลลูกค้า</button>
                        </div>
                    </div>
                </div>
            </form>


            </div>

        )
    }
}